export default __webpack_public_path__ + "static/media/boat.ee601f27.png";